import React, {Component} from 'react'
import {Input} from 'reactstrap'
import PropTypes from 'prop-types'

function InputText(props){
    const {type, id, placeholder, value, onChange, style, disabled} = props
    return(
        <Input type={type ? type : "text"} name="text-input" id={id} placeholder={placeholder} value={value} 
            onChange={onChange} {...props} style={{background: 'rgba(200, 200, 200, 0.15)', 
            border: 0, backdropFilter: 'blur(10)', color: '#fff', ...style}} disabled={disabled}
        />
    )
}

const inputTextPropTypes = {
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired
}

InputText.propTypes = inputTextPropTypes

export default InputText


// WEBPACK FOOTER //
// ./src/views/CustomComponents/InputText.jsx